import { createSlice } from '@reduxjs/toolkit';

const sliceName = 'settingsPreview';

// simple deep merge for plain objects only
const mergeDeep = (target, patch) => {
  Object.entries(patch || {}).forEach(([k, v]) => {
    const tv = target?.[k];
    if (v && typeof v === 'object' && !Array.isArray(v)) {
      if (!tv || typeof tv !== 'object' || Array.isArray(tv)) target[k] = {};
      mergeDeep(target[k], v);
    } else {
      target[k] = v;
    }
  });
};

const initialSearchBoxState = {
  enabled: false,
  leftColumn: '30%',
  rightColumn: '70%',
  categoryBlockEnabled: false,
  categoryBlock: {
    categoryMax: 3,
  },
  historyBlockEnabled: false,
  historyBlock: {
    historyMax: 4,
  },
  suggestionsBlockEnabled: false,
  pillsBlockEnabled: false,
  pillsBlock: {

  },
  products: {
    inRow: 3,
    productsMax: 6, // should be always inRow*2
    orientation: 'vertical',
  },
};

const initialSearchResultsPageState = {
  enabled: false,
  leftColumn: '30%',
  rightColumn: '70%',
  products: {
    productsMax: 24,
  },
};

const initialWidgetState = {
  enabled: false,
  leftColumn: '30%',
  rightColumn: '70%',
};

//   const [headersColor, setHeadersColor] = useState('#2b2b2b');
//   const [mainColor, setMainColor] = useState('#3a3a3a');
//   const [accentColor, setAccentColor] = useState('#121a4b');
//   const [buttonColor, setButtonColor] = useState('#a22d2d');
//   const [borderColor, setBorderColor] = useState('#cfcfcf');
//   const [backgroundColor, setBackgroundColor] = useState('#ffffff');

const initialColorsState = {
  headersColor: '#2b2b2b',
  mainColor: '#3a3a3a',
  accentColor: '#121a4b',
  buttonColor: '#a22d2d',
  borderColor: '#cfcfcf',
  backgroundColor: '#ffffff',
};

const diff = {
  isFetched: false,
  searchBox: initialSearchBoxState,
  widget: initialWidgetState,
  searchResultsPage: initialSearchResultsPageState,
  colors: initialColorsState,
};

const initialState = {
  ...diff,
  forDiff: diff,
};

const SettingsPreview = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    // general patch at top level (e.g., isFetched or entire blocks)
    updateSettingsPreview(state, { payload }) {
      mergeDeep(state, payload);
    },

    resetPreviewSettings(state) {
      mergeDeep(state, state.forDiff);
    },

    // specific updates
    updateSearchBoxPreview(state, { payload }) {
      mergeDeep(state.searchBox, payload);
    },
    updateWidgetPreview(state, { payload }) {
      mergeDeep(state.widget, payload);
    },
    updateSearchResultsPagePreview(state, { payload }) {
      mergeDeep(state.searchResultsPage, payload);
    },
    updateColorsPreview(state, { payload }) {
      mergeDeep(state.colors, payload);
    },
  },
});

export const { actions, reducer } = SettingsPreview;
export const {
  updateSettingsPreview,
  updateColorsPreview,
  updateSearchBoxPreview,
  resetPreviewSettings,
  updateWidgetPreview,
  updateSearchResultsPagePreview,
} = actions;
export default reducer;
